export default {
    go: '前往',
    operateDone: '已操作完成',
    goNextTask: '自动为您跳转至下一条待办',
    printConfirmTitle: '温馨提示',
    printConfirmContent: '钉钉工作台内不支持系统打印，请点击“前往”浏览器打印',
};
